import { Modal } from 'antd'

import styles from './confirmDeleteTask.module.css'

export const getDeleteTaskTypeLabel = (type) =>
    String(type || 'Task').trim().toLowerCase() || 'task'

export const getDeleteTaskMenuLabel = (type) =>
    `Delete ${getDeleteTaskTypeLabel(type)}`

/**
 * Shared Ant Design confirm dialog for deleting a task.
 * Used by board/list context menus and task detail view.
 * @param {{ onConfirm?: () => void|Promise<void>, type?: string }} [options]
 */
export const confirmDeleteTask = ({ onConfirm, type } = {}) => {
    const itemLabel = getDeleteTaskTypeLabel(type)

    Modal.confirm({
        title: `Delete this ${itemLabel}?`,
        content: `This ${itemLabel} will be removed from the project. This cannot be undone.`,
        okText: 'Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        centered: true,
        maskClosable: true,
        okButtonProps: {
            danger: true,
            type: 'primary',
            className: styles.deleteBtn,
        },
        cancelButtonProps: {
            className: styles.cancelBtn,
        },
        onOk: async () => {
            if (typeof onConfirm === 'function') {
                await onConfirm()
            }
        },
    })
}

export default confirmDeleteTask
